import styled, { css } from "styled-components";
import { PriceUIType } from "./index";
import { px2rem } from "../../../../../utils/css";
export const PriceBox = styled.div `
	display: flex;
	align-items: baseline;
	${(props) => {
    switch (props.type) {
        case PriceUIType.Small:
            return css `
					.current {
						font-size: ${px2rem(12)};
						height: ${px2rem(16)};
					}
				`;
        case PriceUIType.Middle:
            return css `
					.current {
						font-size: ${px2rem(14)};
						height: ${px2rem(19)};
						margin-right: ${px2rem(6)};
					}
				`;
        case PriceUIType.Large:
            return css `
					.current {
						font-size: ${px2rem(16)};
						height: ${px2rem(22)};
						margin-right: ${px2rem(3)};
					}
				`;
    }
}}
`;
export const CurrentPrice = styled.p `
	color: #333333;
	font-family: Avenir-Heavy, Avenir;
	font-weight: 800;
`;
export const OriginPrice = styled.p `
	font-size: ${px2rem(12)};
	color: #999;
	text-decoration: line-through;
`;
